import React from 'react';
import ProjectCard from './ProjectCard';
import DownArrowIcon from '../../assets/down-arrow3.svg';
import { projects } from './data';
import styles from './styles.module.scss';

function Projects() {
	return (
		<div className={`box moreBox ${styles.projectContainer}`} id='projectBox'>
			<h6 className='note'>* hover for info or click on touch screens</h6>
			<h1 className='section-title'>Projects</h1>

			<div className={styles.projectInnerContainer}>
				{projects.map((item) => (
					<div className={styles.flipCard}>
						<div className={styles.flipCardInner}>
							<ProjectCard
								img={item.img}
								title={item.title}
								type={item.type}
								description={item.description}
								link={item.link}
								button={item.button}
							/>
						</div>
					</div>
				))}
			</div>

			<a href='#ExtraCurrBox'>
				<img src={DownArrowIcon} alt='arrow' className='downArrow'></img>
			</a>
		</div>
	);
}

export default Projects;
